module.exports = __webpack_public_path__ + "img/2.855233f8.png";